<ng-template #contentTpl>
  <ng-container *transloco="let t">
    @if (isOffline()) {
      <div class="glass absolute inset-0 flex justify-center items-center z-[200000]">
        <div class="card bg-base-100 w-96 shadow-2xl rounded-none">
          <div class="card-body">
            <h2 class="card-title">{{ t("error.offline.title") }}</h2>
            <div class="card-actions gap-3 flex pl-2">
              <i-lucide [img]="errorIcon" [size]="28"></i-lucide>
              <p>{{ t("error.offline.message") }}</p>
              @if (countdown() !== 0) {
                <p>
                  {{ t("error.offline.retryIn", { seconds: countdown() }) }}
                </p>
              }
              @if (countdown() === 0) {
                <p>{{ t("error.offline.connecting") }}</p>
              }
            </div>
          </div>
        </div>
      </div>
    }
    <ng-content [attr.aria-hidden]="isOffline()"></ng-content>
  </ng-container>
</ng-template>

@if (!shellService.hideShell()) {
  <ng-container>
    <app-shell-default-uif>
      <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </app-shell-default-uif>
  </ng-container>
}

@if (shellService.hideShell()) {
  <ng-container>
    <app-shell-hidden-uif>
      <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </app-shell-hidden-uif>
  </ng-container>
}
